import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tabcontent" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "info-header" }
const _hoisted_4 = {
  key: 1,
  class: "country-name"
}
const _hoisted_5 = {
  key: 2,
  className: "flag-right"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { className: "info-content" }

import { onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { InfosModel } from '@/models/sidebar/info.model';

import SourceTooltip from './SourceTooltip.vue';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
    _id: {},
    country: {},
    cssClass: {},
    flag: {},
    location: {},
    source: {},
    text: {},
    sources: {}
  },
  setup(__props: any) {

const windowWidth = ref(window.innerWidth);

const sourceOverlay = ref();
const hovering = ref(false);
const hideTimeout = ref<ReturnType<typeof setTimeout> | null>(null);

const props = __props;

const { t } = useI18n();

onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

function updateWidth() {
  windowWidth.value = window.innerWidth;
}

function isTouchDevice() {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}

function showOverlay(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();

  hovering.value = true;
  if (sourceOverlay.value) {
    sourceOverlay.value.show(event);
  }
}

function hideOverlayWithDelay() {
  hovering.value = false;
  hideTimeout.value = setTimeout(() => {
    if (!hovering.value) {
      sourceOverlay.value?.hide();
    }
  }, 100);
}

function cancelHide() {
  hovering.value = true;
  if (hideTimeout.value) {
    clearTimeout(hideTimeout.value);
    hideTimeout.value = null;
  }
}

function setView() {
  if (props.location) {
    window.map.setView([props.location[0], props.location[1]]);
    window.map.fire('moveend');
  }
}

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: props._id,
      className: "infoCard"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (props.cssClass)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(props.cssClass + ' circle-fa'),
              onClick: setView
            }, null, 2))
          : _createCommentVNode("", true),
        (props.country)
          ? (_openBlock(), _createElementBlock("b", _hoisted_4, _toDisplayString(props.country), 1))
          : _createCommentVNode("", true),
        (props.flag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                className: "actual-flag",
                src: props.flag,
                alt: "404"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(props.text) + " ", 1),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isTouchDevice() ? showOverlay($event) : null), ["prevent"])),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (!isTouchDevice() ? showOverlay($event) : null)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (!isTouchDevice() ? hideOverlayWithDelay() : null))
        }, [
          _createTextVNode(_toDisplayString(_unref(t)('sidebar.source')) + " ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", {
            class: "pi pi-external-link",
            style: {"font-size":"1.2rem"}
          }, null, -1))
        ], 32),
        _createVNode(_component_OverlayPanel, {
          onMouseenter: cancelHide,
          onMouseleave: hideOverlayWithDelay,
          ref_key: "sourceOverlay",
          ref: sourceOverlay,
          style: _normalizeStyle({
            maxWidth: '80vw',
            maxHeight: '60vh',
            padding: '1px',
            overflow: 'hidden',
            backgroundColor: _unref(store).state.dark ? '#121722' : '#fff',
            color: _unref(store).state.dark ? '#E6EAF2' : '#000',
            fontFamily: 'inherit',
            zIndex: 9999
          })
        }, {
          default: _withCtx(() => [
            _createVNode(SourceTooltip, {
              source: props.source,
              sources: props.sources
            }, null, 8, ["source", "sources"])
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})